import React from 'react';
import clsx from 'clsx';
import { Typography } from '../common';
import { format, parseISO } from 'date-fns';

interface Props {
	date: string;
	className?: string;
}

export const MessageDate: React.FC<Props> = ({ date, className }) => {
	return (
		<Typography
			type="regular-12"
			className={clsx('text-opacity-black !text-left', className)}
		>
			{format(parseISO(date), 'MM/dd/yyyy, h:mm a')}
		</Typography>
	);
};
